import { Pipe, PipeTransform } from '@angular/core';

import calculatePercentage from '../../utils/calculate-percentage/calculate-percentage';

@Pipe({
  name: 'calcPercent',
})
export class CalculatePercentagePipe implements PipeTransform {
  transform(partialValue: number, total: number): number {
    return calculatePercentage(partialValue, total);
  }
}
